/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useRef, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAlert from "components/MDAlert";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "../../examples/Tables/DataTable";
import useApi from "../../components/Utils/api";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import PermissionControl from "../../components/Utils/PermissionControl";
import {useTranslation} from "react-i18next";
import Switch from "@mui/material/Switch";
import Tooltip from "@mui/material/Tooltip";
import PropTypes from "prop-types";
import {formatDate} from "../../utils"
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
function MerchantGroups() {
  // const { merchantGroupTablecolumns } = data();
  const {t} = useTranslation();
  const [merchants, setMerchants] = useState([]);
  const navigate = useNavigate();
  const api = useApi();
  const getMerchantGroups = () => {
    api.get("admin/browseMerchantGroup")
      .then((response) => {
        if(response.data.statusCodeValue === 200) {
          setMerchants(response.data.body);
        } else {
          toast.error(response.data.error);
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 403) {
          toast.error(t('you_do_not_have_permission_to_perform_this_action'), { id: "PermissionError" });
          return;
        }
      })
  }
  const makeDefault = (referenceId) => {
    api.get("organization/update-default/"+referenceId)
        .then((response) => {
            console.log(response);
          if(response.data.status === "200") {
              getMerchantGroups();
            toast.success(response.data.message);
          } else {
            toast.error(response.data.error);
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 403) {
            toast.error(t('you_do_not_have_permission_to_perform_this_action'), { id: "PermissionError" });
            return;
          }
        })
  }
    const rowHandler = (org)  => {
        console.log("triggered", org)
        navigate("/merchant-group/single", {
            state: {
                referenceCompany: org.row.original,
                merchantGroups: merchants
            }
        })
    }
  const merchantGroupTablecolumns = [
    { Header: () => t("merchantGroupTablecolumns.referenceId"), accessor: "referenceId", width: "10%", align: "left" },
    { Header: () => t("merchantGroupTablecolumns.referenceCompanyName"), accessor: "referenceCompanyName", width: "10%", align: "left" },
    { Header: () => t("merchantGroupTablecolumns.ownerName"), accessor: "ownerName", width: "10%", align: "left" },
    { Header: t("merchantGroupTablecolumns.status"), accessor: row => row.status === "1" ? 'Active' : row.status === "3" ? 'Block' : 'In Active', width: "10%", align: "left" },
    { Header: "Is Default", accessor: "isDefault", width: "10%", align: "left", Cell: (org) => {
        const value = org?.row?.original?.isDefault;
        return (
            <>
            <PermissionControl permission={{ restrict: true, module: "Organization", subModule: "UpdateDefault" }} >
              <Switch
                  checked={value}
                  onChange={() => makeDefault(org?.row?.original?.referenceId)}
                  inputProps={{ 'aria-label': 'controlled' }}
              />
            </PermissionControl>
            </>
        );
      }
    },
    { Header: t("merchantTablecolumns.created_at"), accessor: 'createdDt', Cell: ({cell}) => formatDate(cell.value), width: "10%", align: "left" },
    { Header: "Details", accessor: 'details', Cell: (row) => {
            return (
                <>
                    <Tooltip title="View Details" arrow>
                        <div>
                            <RemoveRedEyeIcon onClick={() => rowHandler(row)} className='text-inheriti text-xl' />
                        </div>
                    </Tooltip>
                </>
            );
        }
      , width: "10%", align: "left" },
  ];
  useEffect(() => {
    getMerchantGroups();
  },[]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={6} mb={3}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={12}>
            <PermissionControl permission={{ restrict: true, module: "Organization", subModule: "Create" }}>
              <MDButton color="info" size="medium" style={{ marginLeft: 'auto', display: 'block' }} variant="contained" onClick={() => navigate("/merchant-group/single", { state: { merchantGroups: merchants }  })}>{t('new')}</MDButton>
            </PermissionControl>
          </Grid>
          <Grid item xs={12} lg={12}>
            <DataTable
              table={{ columns : merchantGroupTablecolumns, rows : merchants }}
              showTotalEntries={true}
              isSorted={true}
              noEndBorder
              entriesPerPage={true}
              canSearch={true}
            />
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
MerchantGroups.propTypes = {
  cell: PropTypes.shape({
    value: PropTypes.any.isRequired,
  }),
};
export default MerchantGroups;
